// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3q8xd","col":"styles_col__1zyTX"};